import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const openButtonContainer = css`
  min-inline-size: fit-content;
  padding-inline: ${spacing(1)};
`
